<template>
  <v-menu offset-y v-model="show" :allow-overflow="true" :class="klass">
    <template v-slot:activator="{ on }">
      <v-text-field
        :class="klass"
        color="primary"
        v-model="addressLine"
        v-on="on"
        :label="$i18n.t(label)"
        :loading="loading"
        :clearable="clearable"
        :rules="rules"
        autocomplete="nope"
        :disabled="disabled"
      >Dropdown</v-text-field>
    </template>
    <v-list elevation="0" v-if="addreses.length > 0">
      <v-list-item v-for="(address, index) in addreses" :key="index" @click="select(address)">
        <v-list-item-title>{{ address }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import { commonMixin } from "@/mixins/common";
import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "ChargeType",
  props: {
    value: {
      default: false,
    },
    label: {
      default: null,
    },
    clearable: {
      default: false,
    },
    rules: {
      default: () => [],
    },
    klass: {
      default: null,
    },
    disabled: {
      default: false,
    },
  },
  mixins: [Themeable, commonMixin],
})
export default class AssistanceType extends (Vue, Themeable) {
  address = "";
  addressLine = null;
  addreses = [
    "Base Fare",
    "Per Tonne",
    "Per KG",
    "Per KM",
    "Extra Distance Fare",
    "Labour Charge",
    "Assitance Charge",
  ];
  loading = false;
  show = false;

  mounted() {
    this.onValueChange(this.value);
  }

  select(address) {
    this.address = address;
    if (address) this.addressLine = address;
    else this.addressLine = null;
  }

  clear() {
    this.addressLine = null;
    this.address = "";
    this.$emit("input", {});
  }

  @Watch("value")
  onValueChange(val) {
    this.address = val;
    if (this.address) {
      this.addressLine = this.address;
    } else {
      this.addressLine = null;
    }
  }

  @Watch("addressLine")
  async onFilterChange(val) {
    if (this.address == null) this.address = "";
    this.address = val;
    this.$emit("input", this.address);
  }

  @Watch("addresses")
  onAddressChange(val) {
    if (val == null || val.length == 0) this.show = false;
  }

  onClick() {
    this.onAddressChange(this.addreses);
  }
}
</script>

<style scoped>
.filterBox {
  position: sticky;
  background: white;
  top: 0;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}

.v-select-list {
  padding: 0;
}
.menuable__content__active,
.v-menu__content {
  background: white;
}
.v-select__selections {
  height: 32px;
}
.height32 {
  height: 32px;
}
.text-title {
  min-width: 60px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}
.flag-img {
  float: left;
  margin-right: 10px;
  height: 20px;
  width: 24px;
  margin: 5px 10px 2px 0;
}
</style>
